module.exports = __webpack_public_path__ + "img/5.bada8ccb.png";